export const GOOGLE_OAUTH_STATE = 'google';

const GOOGLE_OAUTH_SCOPES = [
  'https://www.googleapis.com/auth/userinfo.email',
  'https://www.googleapis.com/auth/userinfo.profile'
].join(' ');

export function getGoogleClientId() {
  return String(process.env.REACT_APP_GOOGLE_CLIENT_ID || '').trim();
}

export function getGoogleRedirectUri() {
  return `${window.location.origin}/authorize`;
}

export function buildGoogleAuthUrl() {
  const clientId = getGoogleClientId();

  if (!clientId) {
    return '';
  }

  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: getGoogleRedirectUri(),
    scope: GOOGLE_OAUTH_SCOPES,
    response_type: 'code',
    access_type: 'offline',
    prompt: 'consent',
    state: GOOGLE_OAUTH_STATE
  });

  return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
}
